import { StatusMessage } from '../types';

export const statusMessagesMapping: Record<StatusMessage, string> = {
  INVALID_ACCOUNT: 'Cuenta o tarjeta inválida. Revisa e inténtalo de nuevo.',
  INVALID_AMOUNT: 'El monto de la transacción es inválido. Revisa e inténtalo de nuevo.',
  CUSTOMER_CANCELLATION: 'Tus fondos están seguros. Contacta a tu banco o inténtalo de nuevo.',
  BANK_NOT_AVAILABLE: 'Transacción rechazada por error en el banco. Inténtalo de nuevo.',
  PAYMENT_METHOD_UNAVAILABLE: 'Intermitencias en el medio de pago. Inténtalo más tarde o con otro medio de pago.',
  DOCUMENT_ACCOUNT_MISMATCH: 'Discrepancia entre la cuenta y el documento.',
  EXPIRED: 'Tiempo para realizar el pago ha expirado. Inténtalo de nuevo.',
  ACCOUNT_LIMIT_REACHED: 'Límite de la cuenta alcanzado. Revisa e inténtalo de nuevo.',
  AUTHENTICATION_FAILED: 'Fallo en la autenticación. Inténtalo de nuevo.',
  DECLINED_BY_BANK: 'Rechazado por el banco. Contacta a tu banco o inténtalo de nuevo.',
  NOT_ENOUGH_FUNDS: 'Fondos insuficientes. Revisa e inténtalo de nuevo.',
  ACCOUNT_BLOCKED_OR_INACTIVE: 'Cuenta o tarjeta bloqueada o inactiva. Contacta a tu banco.',
  DECLINED_FOR_SECURITY: 'Rechazo por seguridad. Contáctanos o intenta de nuevo.',
  DUPLICATE_RECORD: 'Registro duplicado. Asegúrate que no tengas otra transacción en curso.',
  UNSUPPORTED_CARD_FRANCHISE: 'Franquicia de tarjeta no soportada. Inténtalo con otra tarjeta.',
  TOO_MANY_ATTEMPTS: 'Demasiados intentos. Contacta a tu banco o inténtalo más tarde.',
  ACCOUNT_EMBARGOED: 'Hubo un error inesperado. Contáctanos para mayor información.',
  ERROR: 'Tus fondos están seguros. Revisa e inténtalo de nuevo.',
};
